if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        // 1) Find the inner <form> and variant <input>
        this.form = this.querySelector('form');
        this.variantInput = this.form.querySelector('[name="id"]');
        this.variantInput.disabled = false;

        // 2) When the form submits, run our AJAX handler
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // 3) Grab either the notification drawer or fallback cart drawer
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        // 4) Stub out any missing methods so we never crash
        if (this.cart && typeof this.cart.getSectionsToRender !== 'function') {
          this.cart.getSectionsToRender = () => [];
        }
        if (this.cart && typeof this.cart.setActiveElement !== 'function') {
          this.cart.setActiveElement = () => {};
        }
        if (this.cart && typeof this.cart.renderContents !== 'function') {
          this.cart.renderContents = () => {
            window.location = window.routes.cart_url;
          };
        }

        // 5) Cache your add-to-cart button & its inner <span>
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.soldOutMessage =
          this.submitButton.querySelector('.sold-out-message') || null;

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        // 6) If they switch options, ALWAYS re-enable the button
        this.variantInput.addEventListener('change', () => {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.submitButtonText.classList.remove('hidden');
          if (this.soldOutMessage) {
            this.soldOutMessage.classList.add('hidden');
          }
        });

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((s) => s.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(window.routes.cart_add_url, config)
          .then((res) => res.json())
          .then((res) => {
            if (res.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: res.errors || res.description,
                message: res.message,
              });
              this.handleErrorMessage(res.description);
              // show sold-out
              if (this.soldOutMessage) {
                this.submitButtonText.classList.add('hidden');
                this.soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            }

            // if no AJAX cart present, full redirect
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: res,
              });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => setTimeout(() => this.cart.renderContents(res)),
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(res);
            }
          })
          .catch((e) => {
            console.error(e);
            // fallback to full cart page
            window.location = window.routes.cart_url;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}
